import type { FC } from 'react'
import { AddressModel, AddressModelJSON } from '~/models/address'

export type AddressProps = {
  title?: string
  address: AddressModelJSON
  className?: string
}

export const Address: FC<AddressProps> = props => {
  const title = props.title ?? '住所'
  const address = props.address instanceof AddressModel ? props.address : AddressModel.fromJSON(props.address)
  const className = props.className ?? ''
  return (
    <div className={`flex flex-row justify-between items-baseline border-b border-gray-300 ${className}`}>
      <h3 className="basis-3/12 md:basis-2/12 text-xs font-medium text-gray-500 mt-auto">{title}</h3>
      <p className="basis-8/12 md:basis-9/12 break-all mt-auto">
        {address.postalCode.format()}<br />
        {address.prefectureCode.getDisplayName()}
        {address.city}
        {address.address1}
        {address.address2}
        {address.building}
      </p>
    </div>
  )
}
